import React from 'react';
import ArticleField from '../ArticleField';
import StrapiSearch from '../StrapiSearch';

interface MainThemeProps {
    value: any,
    onChange: (value: any) => void
}

const MainTheme = (props: MainThemeProps) => (
    <ArticleField label="Thème principal *">
        <StrapiSearch
            collection="themes"
            search_attribute="name"
            value={props.value}
            onChange={props.onChange} />
    </ArticleField>
)

export default MainTheme;